import React from 'react';
import { Text } from '@moda/om';
import classNames from 'classnames';

import './CheckoutHeaderStep.scss';

interface Props {
  title: string;
  checked?: boolean;
}

export const CheckoutHeaderStep: React.FC<Props> = ({ title, checked }) => (
  <div
    className={classNames('CheckoutHeaderStep', {
      'CheckoutHeaderStep--checked': checked
    })}
    aria-label={`${title}, ${checked ? 'completed' : 'not completed'}`}
  >
    <span className="CheckoutHeaderStep__indicator" aria-hidden="true" />
    <Text className="CheckoutHeaderStep__title">{title}</Text>
  </div>
);
